import { useQuery } from '@tanstack/react-query';
import { createBrowserFavouritesService } from '@johnlewispartnership/wtr-website-favourites-sdk';
import type { Favourite } from '@johnlewispartnership/wtr-website-favourites-sdk';
import { useAuthentication } from '@johnlewispartnership/wtr-website-authentication/dist/context';

import config from 'config';
import FavouritesServiceClient from 'services/favourites';

const QUERY_KEY = 'wtr-cr/favourites-service/favourites-list';

const apiClientHeaders = {
  headers: {
    breadcrumb: config.applicationName,
  },
};

export const useFavouritesService = () => {
  const { state } = useAuthentication();
  const { token } = state;
  const isAuthenticated = !!token?.accessToken;

  const favouritesService = createBrowserFavouritesService({
    apiClient: FavouritesServiceClient,
    apiClientOptions: {
      get: { ...apiClientHeaders },
      add: { ...apiClientHeaders },
      remove: { ...apiClientHeaders },
    },
    authenticationClient: {
      getAccessToken: () => token?.accessToken ?? '',
      isAuthenticated: () => isAuthenticated,
    },
  });

  const { data: favourites = [] } = useQuery({
    queryKey: [QUERY_KEY],
    queryFn: () => favouritesService.get(),
    enabled: isAuthenticated,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const favouriteLineNumbers: Record<Favourite['lineNumber'], boolean> = {};

  for (const favourite of favourites) {
    favouriteLineNumbers[favourite.lineNumber] = true;
  }

  return {
    favourites: favouriteLineNumbers,
    add: (lineNumber: string) => favouritesService.add(lineNumber),
    remove: (lineNumber: string) => favouritesService.remove(lineNumber),
  };
};
